//auth
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_OUT = "LOGIN_OUT";
export const LOAD_PROFILE = "LOAD_PROFILE";
export const LOG_OUT = "LOG_OUT";

//api
export const HOME_VIDEOS_SUCCESS = "HOME_VIDEOS_SUCCESS";
export const HOME_VIDEOS_FAIL = "HOME_VIDEOS_FAIL";
export const HOME_VIDEOS_REQUEST = "HOME_VIDEOS_REQUEST";

//get video detail by id
export const SELECTED_VIDEO_REQUEST = "SELECTED_VIDEO_REQUEST";
export const SELECTED_VIDEO_SUCCESS = "SELECTED_VIDEO_SUCCESS";
export const SELECTED_VIDEO_FAIL = "SELECTED_VIDEO_FAIL";

//get channel detail
export const CHANNEL_DETAILS_REQUEST = "CHANNEL_DETAILS_REQUEST";
export const CHANNEL_DETAILS_SUCCESS = "CHANNEL_DETAILS_SUCCESS";
export const CHANNEL_DETAILS_FAIL = "CHANNEL_DETAILS_FAIL";

//get channel subscription detail
export const SET_SUBSCRIPTION_STATUS = "SET_SUBSCRIPTION_STATUS";

//get video comments
export const COMMENT_LIST_REQUEST = "COMMENT_LIST_REQUEST";
export const COMMENT_LIST_SUCCESS = "COMMENT_LIST_SUCCESS";
export const COMMENT_LIST_FAIL = "COMMENT_LIST_FAIL";

//get related videos
export const RELATED_VIDEO_REQUEST = "RELATED_VIDEO_REQUEST";
export const RELATED_VIDEO_SUCCESS = "RELATED_VIDEO_SUCCESS";
export const RELATED_VIDEO_FAIL = "RELATED_VIDEO_FAIL";

//get video by search
export const SEARCH_VIDEO_REQUEST = "SEARCH_VIDEO_REQUEST";
export const SEARCH_VIDEO_SUCCESS = "SEARCH_VIDEO_SUCCESS";
export const SEARCH_VIDEO_FAIL = "SEARCH_VIDEO_FAIL";
